import type { ReactNode } from 'react';

export const symbol_travel_luggage_and_bags: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M200-185v-475q0-24.75 17.63-42.38Q235.25-720 260-720h105v-125q0-14 10.5-24.5T400-880h160q14 0 24.5 10.5T595-845v125h105q24.75 0 42.38 17.62Q760-684.75 760-660v475q0 24.75-17.62 42.37Q724.75-125 700-125v15q0 12.75-8.62 21.37Q682.75-80 670-80q-13 0-21.5-8.5T640-110v-15H320v15q0 12.75-8.62 21.37Q302.75-80 290-80q-13 0-21.5-8.5T260-110v-15q-24.75 0-42.37-17.63Q200-160.25 200-185Zm225-535h110v-100H425v100Zm169.5 222Q651-511 700-542v-118H260v118q49 31 105.5 44T480-485q58 0 114.5-13ZM450-410v-11q-51-3-99-16.5T260-477v292h440v-292q-43 26-91 39.5T510-421v11q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63-8.5-8.62-8.5-21.37Zm30 30Zm0-105Zm0 8Z"
		/>
	</svg>
);
